import { dataSource } from '@/data';
import type { FiltrosIncidentes, IncidenteResumo } from '@/data/types';
import { useEventos } from './use-eventos';
import { usePaginaCursor, type ListaPaginada } from './use-pagina-cursor';

export type ListaIncidentes = ListaPaginada<IncidenteResumo>;

/** Lista de incidentes paginada por cursor; relê em silêncio quando um incidente muda em outra tela. */
export function useIncidentes(filtros: FiltrosIncidentes): ListaIncidentes {
  const lista = usePaginaCursor(
    filtros,
    (f, cursor, signal) => dataSource.listarIncidentes(f, cursor, signal),
    (item) => item.id,
  );
  const { atualizarEmSilencio } = lista;
  useEventos((evento) => {
    if (evento.tipo === 'incidente') atualizarEmSilencio();
  });
  return lista;
}
